import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { ResponseTemplate } from '@erp/shared';

/** Modelos de resposta (composer) e de apontamento — mesma forma no shared. */
export type ModelKind = 'responses' | 'appointments';

export const MODEL_KIND_LABELS: Record<ModelKind, string> = {
  responses: 'resposta',
  appointments: 'apontamento',
};

/**
 * GET /models/responses|appointments — sem desk_id lista TODOS (página de
 * gestão); com desk_id devolve os da mesa + os globais (uso nos dropdowns
 * "Modelo" do ticket).
 */
export function modelTemplatesOptions(kind: ModelKind, deskId?: number) {
  return queryOptions({
    queryKey: ['erp', 'models', kind, { deskId: deskId ?? null }] as const,
    queryFn: async ({ signal }) => {
      const res = await api<ResponseTemplate[]>(`/models/${kind}`, {
        query: { desk_id: deskId },
        signal,
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
